import styled from 'styled-components';

export const TextBlack = styled.div`
  color: ${(props) => props.theme.colors.text.black};
  font-family: 'Noto Sans KR', sans-serif;
  font-size: ${(props) => props.size || '14px'};
  font-style: normal;
  font-weight: ${(props) => props.weight || '400'};
  line-height: ${(props) => props.lineHeight || 'normal'};
  margin: ${(props) => props.margin || '0'};
  padding: ${(props) => props.padding || '0'};
  text-align: ${(props) => props.align || 'left'};
  word-break: keep-all;
`;

export const TextWhite = styled.div`
  color: #fff;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: ${(props) => props.size || '14px'};
  font-style: normal;
  font-weight: ${(props) => props.weight || '400'};
  line-height: 1.5;
  margin: ${(props) => props.margin || '0'};
  padding: ${(props) => props.padding || '0'};
  text-align: ${(props) => props.align || 'left'};
  /* line-break: strict; */
  word-break: keep-all;

  @media screen and (max-width: 420px) {
    mr {
      &::after {
        content: '';
        display: block;
      }
    }
  }
`;

export const TextPrimary = styled.span`
  color: ${(props) => props.theme.colors.primary.solid};
  font-family: 'Noto Sans KR', sans-serif;
  font-size: ${(props) => props.size || '14px'};
  font-style: normal;
  font-weight: ${(props) => props.weight || '400'};
  line-height: ${(props) => props.lineHeight || 'normal'};
  margin: ${(props) => props.margin || '0'};
  padding: ${(props) => props.padding || '0'};
  text-align: ${(props) => props.align || 'left'};
  word-break: break-all;
`;

export const TextCustomColor = styled.span`
  color: ${(props) => props.color};
  font-family: 'Noto Sans KR', sans-serif;
  font-size: ${(props) => props.size || '14px'};
  font-style: normal;
  font-weight: ${(props) => props.weight || '400'};
  line-height: ${(props) => props.lineHeight || 'normal'};
  margin: ${(props) => props.margin || '0'};
  padding: ${(props) => props.padding || '0'};
  text-align: ${(props) => props.align || 'left'};
  word-break: break-all;
`;
